import { render, staticRenderFns } from "./ItEnderecoFormSection.vue?vue&type=template&id=9677b578"
import script from "./ItEnderecoFormSection.vue?vue&type=script&lang=ts"
export * from "./ItEnderecoFormSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports